import AnimatedCounter from "./AnimatedCounter";

export default function StatCard({ label, value, icon: Icon, accent = "#FFBF00", testId }) {
  return (
    <div
      data-testid={testId}
      className="group relative overflow-hidden rounded-3xl card-cartoon hover-blocky p-5 sm:p-6 blocky-shadow"
      style={{ borderColor: accent + "33" }}
    >
      <div
        className="absolute -top-16 -right-16 w-40 h-40 rounded-full blur-3xl opacity-25 group-hover:opacity-40 transition-opacity"
        style={{ background: accent }}
      />
      <div className="flex items-center gap-3 text-white/60">
        {Icon && <Icon size={18} style={{ color: accent }} />}
        <div className="text-[11px] uppercase tracking-[0.3em] font-bold">{label}</div>
      </div>
      <div className="mt-3 font-hero text-4xl sm:text-5xl text-white">
        <AnimatedCounter value={value} />
      </div>
    </div>
  );
}
